export function parseCoupon<T>(query_coupon: string): T | string {
    try {
        return JSON.parse(query_coupon);
    } catch (err) {
        return query_coupon;
    }
}
